// extracted by mini-css-extract-plugin
export var alternate = "_13-j";
export var black = "_13-6";
export var blue = "_13-f";
export var blueLight = "_13-e";
export var brand = "_13-8";
export var darkMode = "_13-b";
export var error = "_13-a";
export var gray = "_13-5";
export var grayBlue = "_13-d";
export var iconWrapper = "_13-3";
export var inactive = "_13-7";
export var indigo = "_13-g";
export var orange = "_13-i";
export var pink = "_13-h";
export var primary = "_13-0";
export var purple = "_13-9";
export var success = "_13-4";
export var warning = "_13-c";
export var white = "_13-1";
export var whiteSuccess = "_13-2";